<template>
<section class="box analytics display-pc">
  <com-h1 title="参会者分析"></com-h1>
  <div class="container">
    <div class="total-analysis">
      <div class="left-detail">
        <div class="top-detail">
          <h3>工作年限</h3>
          <span>8年以上占 48%</span>
          <span>5-8年占 31%</span>
          <span>3-5年占 18%</span>
          <span>3年以下占 5%</span>
        </div>
        <div class="bottom-detail">
          <h3>职业</h3>
          <span>高级工程师占 31%</span>
          <span>工程师占 14%</span>
           <span>团队Leader占 12%</span>
          <span>高级架构师占 12%</span>
           <span>架构师占 16%</span>
          <span>技术总监占 8%</span>
          <span>项目经理占 2%</span>
          <span>CTO/CIO占 2%</span>
          <span>产品经理占 1%</span>
          <span>其他占 5%</span>
        </div>
      </div>
      <img src="./home-analytics-2.svg">
      <img src="./home-analytics-1.svg">
    </div>
    <h6>参会者数据分析仅供参考</h6>
    <h5 v-if="false">试试 <router-link :to="'/convince-your-boss'" target="_blank">说服老板</router-link> 为你的大会门票报销</h5>
  </div>
</section>
</template>

<script>
import ComH1 from '@/components/com-h1'

export default {
  components: {
    ComH1
  },
  props: [],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  },
  filters: {
  }
}
</script>

<style lang="sass" scoped>
@import "../../../style/variable"

.analytics
  background: url('./analysis.jpg') repeat-x center
  background-size: 100% 100%

.total-analysis
  &:after
    content: ''
    display: block
    clear: both
.left-detail
  float: left
  width: 190px
  text-align: left
  h3
    font-size: 13px
    color: #231815
    padding-bottom: 6px
  span
    font-size: 12px
    display: block
    color: #a1a0a1
    margin-top: 9px
    &:before
      counter-increment: section
      content: counter(section)
      display: inline-block
      color: #fff
      width: 15px
      height: 15px
      line-height: 13px !important
      background-color: $primary
      border-radius: 50%
      text-align: center
      margin-right: 8px
  .top-detail
    counter-reset: section
    padding-bottom: 22px
    margin-top: -35px
    border-bottom: 1px solid #8e9ca9
    line-height: 1em
  .bottom-detail
    counter-reset: section
    margin-top: 21px
    line-height: 1em
    span
      &:before
        background-color: transparent
        border: 1px solid $primary*1.5
        color: $primary*1.5
img
  float: left
  width: 300px
img:first-of-type
  margin-left: 37px
img:last-of-type
  margin-left: 142px
h6
  font-size: 14px
  color: #8e9ca9
  text-align: center
h5
  text-align: center
  padding-top: 10px
  a
    color: $primary2
  a:hover
    color: $primary2
</style>
